import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { httpClient } from "../../services/httpClient";
import { hoursToMilliseconds } from "date-fns";

export const useGetQuestionnaireCountsPerProgramQuery = () =>
  useQuery({
    queryKey: ["questionnaireCounts"],
    queryFn: async () => {
      const { data } = await httpClient.get<QuestionnaireCounts>(
        "indianapolis/questionnaire-counts",
      );
      return data;
    },
    staleTime: hoursToMilliseconds(12),
  });

export type QuestionnaireCounts = Record<string, number>;
